const DIRECTIONS_COLUMN = 'Direction';

export default DIRECTIONS_COLUMN;
